(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("monaco-editor"), require("@otjs/plaintext"), require("@otjs/plaintext-editor"), require("mitt"));
	else if(typeof define === 'function' && define.amd)
		define(["monaco-editor", "@otjs/plaintext", "@otjs/plaintext-editor", "mitt"], factory);
	else if(typeof exports === 'object')
		exports["@otjs/monaco"] = factory(require("monaco-editor"), require("@otjs/plaintext"), require("@otjs/plaintext-editor"), require("mitt"));
	else
		root["@otjs/monaco"] = factory(root["monaco-editor"], root["@otjs/plaintext"], root["@otjs/plaintext-editor"], root["mitt"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__643__, __WEBPACK_EXTERNAL_MODULE__929__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__56__) {
return 